<div class="users-container">
    <div class="page-top-banner">
        <div class="title">Utilisateurs Centrex</div>
        <div class="action-zone">
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Plateforme :</mat-label>
                <mat-select [(ngModel)]="platform" (ngModelChange)="onPlatformChange()">
                    <mat-option value="Centrex NG">Centrex NG</mat-option>
                    <mat-option value="Centrex Enreach">Centrex Enreach</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form">
            <div class="mat-elevation-z8 general-table">
                <table mat-table class="default-table" [dataSource]="dataSource" matSort>

                    <!-- Nom -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header="name">Nom</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput (input)="onInput($event, 'name')" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('name')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let user">{{ getNom(user) }}</td>
                    </ng-container>

                    <!-- Prénom -->
                    <ng-container matColumnDef="prenom">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Prénom</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput (input)="onInput($event, 'prenom')" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('prenom')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let user">{{ getPrenom(user) }}</td>
                    </ng-container>

                    <!-- Extension -->
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Extension</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput (input)="onInput($event, 'number')" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('number')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let user">{{ user.number }}</td>
                    </ng-container>

                    <!-- Site ID -->
                    <ng-container matColumnDef="siteId">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Site</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput (input)="onInput($event, 'siteId')" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('siteId')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>

                        <td mat-cell *matCellDef="let user">
                            {{ getSiteName(user) }}
                        </td>
                    </ng-container>

                    <!-- Identifiant -->
                    <ng-container matColumnDef="account">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Identifiant</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput (input)="onInput($event, 'account')" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('account')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let user">{{ user.account }}</td>
                    </ng-container>

                    <!-- Email -->
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Email</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput (input)="onInput($event, 'email')" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('email')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let user">{{ getEmail(user) }}</td>
                    </ng-container>

                    <!-- Bloqué -->
                    <ng-container matColumnDef="blocked">
                        <th mat-header-cell *matHeaderCellDef>Bloqué</th>
                        <td mat-cell *matCellDef="let user">
                            <span [ngClass]="{ red: isBlocked(user), green: !isBlocked(user) }">
                                {{ isBlocked(user) ? 'oui' : 'non' }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Actions -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let user">
                            <div class="actions-cell">
                                <button mat-icon-button (click)="openDialog('view', user)">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                @if (isFullAccess) {
                                <button mat-icon-button (click)="openDialog('edit', user)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        </form>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
</div>
<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.8)" color="#00D2B4" size="large" type="timer"
  [fullScreen]="false"></ngx-spinner>